import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
// import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
// import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDatepicker } from "@angular/material/datepicker";

@Component({
  selector: "app-material-datepicker",
  templateUrl: "./material-datepicker.component.html",
  styleUrls: ["./material-datepicker.component.scss"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    // {
    //   provide: DateAdapter,
    //   useClass: MomentDateAdapter,
    //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    // },
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MaterialDatepickerComponent implements OnInit {
  feedDays:number
  @Output() selectedDates = new EventEmitter();
  @Input() date: Date;
  @Input() opens = 'center';
  @Input('feedDays')
  set setDays(val){
    this.feedDays = val
    this.setFeedDays()
  }
  @Input() futureDays: number;
  @Input() disabled: boolean;
  @Output() dateChangeEvent = new EventEmitter<Date>();
  today = moment().startOf("day").toDate();
  selectedDate;
  @Input("selectedDate")
  set in(val) {
    if (val) {
      this.selectedDate = val;
    } else {
      this.selectedDate = "";
    }
  }
  dayLimit = moment().subtract(0, "days").toDate();
  shouldSetDayLimit = false;
  maxDate: Date;
  constructor() {
    this.feedDays = 30;
    this.date = new Date();
    this.disabled = false;
    this.futureDays = 0;
    this.today = moment(this.date).startOf("day").toDate();
    this.dayLimit = new Date();
  }
  setFeedDays(){
    if (!isNaN(this.feedDays) && this.feedDays >= 0) {
      this.dayLimit = moment()
        .subtract(this.feedDays.toString(), "days")
        .toDate();
      this.shouldSetDayLimit = true;
    }
   }
  ngOnInit(): void {
    // if (this.date && this.date.getTime() > 0) {
    //   this.selectedDate = moment(this.date).startOf("day").toDate();
    // }
    if (this.futureDays) {
      this.maxDate = moment()
        .add(this.futureDays, "days")
        .startOf("day")
        .toDate();
    } else {
      this.maxDate = moment().startOf("day").toDate();
    }
  }
  onDateChange(e) {
    this.selectedDates.emit(e);
  }
  dateChangd() {
    this.selectedDates.emit(this.selectedDate);
  }
}
